import React from "react";
import { createRoot } from "react-dom/client";
import { AppProvider } from "@/components/app/AppProvider";
//Buffer needs this to work in the CI/CD builds
import { Buffer as BufferPolyfill } from "buffer";
import "./main.css";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
declare const Buffer: typeof BufferPolyfill;

globalThis.Buffer = BufferPolyfill;

const domElement = document.getElementById("root");

if (domElement) {
  createRoot(domElement).render(
    <React.StrictMode>
      <AppProvider />
    </React.StrictMode>,
  );
}
